import { MolsonBox, MolsonButton, MolsonTypography } from '@components/reusable'
import errorPng from './error.png'

// biome-ignore lint/suspicious/noExplicitAny: <->
export const DataFetchingError = ({ retry }: { retry?: any }) => {
  return (
    <MolsonBox
      dataTestId="data-fetching-error"
      sx={{
        gap: 2,
        left: '50%',
        position: 'absolute',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      {/* <MolsonIcon
          sx={{ '& > *': { fill: theme.palette.primary.main } }}
          customVariant="EQUIPMENT"
        /> */}
      <img src={errorPng} alt="errorpng" width={32} height={32} />

      <MolsonBox
        maxWidth={350}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <MolsonTypography variant="h3">Could not load data</MolsonTypography>
        <MolsonTypography textAlign="center" mb={2}>
          Refresh the page to reload the data. If the error persists, contact
          your administrator.
        </MolsonTypography>
        {retry ? (
          <MolsonButton variant="outlined" color="secondary" onClick={retry}>
            Retry
          </MolsonButton>
        ) : null}
      </MolsonBox>
    </MolsonBox>
  )
}
